<template>
    <p>Edit Page</p>
</template>

<script>
export default {};
</script>

<style></style>
